namespace SorAraBul.Definitions {
    export interface RestrictionsForm {
        Name: Serenity.StringEditor;
        PropertyType: Serenity.EnumEditor;
    }

    export class RestrictionsForm extends Serenity.PrefixedContext {
        static formKey = 'Definitions.Restrictions';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!RestrictionsForm.init)  {
                RestrictionsForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.EnumEditor;

                Q.initFormType(RestrictionsForm, [
                    'Name', w0,
                    'PropertyType', w1
                ]);
            }
        }
    }
}
